<app-image-card
  *ngIf="video"
  imgS="/assets/images/consultations/CS_S.jpg"
  imgL="/assets/images/consultations/CS_L.jpg"
>
  <app-image-card-tag>
    <p class="ctg1-semibold text-white">
      {{ 'CONSULTATION.FREE_30_MINUTE' | translate | uppercase }}
    </p>
  </app-image-card-tag>
  <app-image-card-title class="mb-0">
    <p class="ct1-bold text-white">
      {{ 'CONSULTATION.TALK_WITH_OUR' | translate }}
    </p>
  </app-image-card-title>

  <app-image-card-button>
    <div class="d-flex flex-wrap">
      <button
        class="b2-semibold gbtn-red-4 gbtn-sq gmr-sm-12 gmb-12 gmb-sm-0"
        (click)="book()"
      >
        {{ 'RESULTS.ID.CONSULT.BTN' | translate }}
      </button>
      <button
        class="b2-semibold gbtn-1 gbtn-bg gbtn-sq gbtn-prefix"
        (click)="openVideoModal()"
      >
        <i class="gpicon-video ms-2"></i>
        {{ 'RESULTS.ID.CONSULT.VIDEO' | translate }}
      </button>
    </div>
  </app-image-card-button>
</app-image-card>
